<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene12',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene12 = this.$scene

    const container = new Container()
    this.$scene.addChild(container)

    const bkg_container = new Container()
    const front_container = new Container()

    this.setCenterContainer(bkg_container)
    this.setCenterContainer(front_container)

    container.addChild(bkg_container)
    container.addChild(front_container)

    const sub0 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {

      'bg': { ref: 'bg_s12', container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }},
      'doors': { ref: 'doors_s12', container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -14, y: 426 }},
      'doors_open': { container: front_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 1, y: 411 }},
      'white': { container: front_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, scale: this.$root.$scale*0.25, x: -1, y: 173 },
      'front': { ref: 'front_s12', container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 } },
      'doors_purple': { container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 } },
    }

    _.each(els, (el, name)=>{
      let sp = null
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.anchor.set(.5)
      if(!el.pivot) { sp = sprite }
      else {
        const cn = new Sprite()
        sprite.x = el.pivot.x/2
        sprite.y = el.pivot.y/2 
        cn.addChild(sprite)
        sp = cn
      }
      sp.alpha = el.alpha
      el.container.addChild(sp)
      sprites[name] = sp
      this.applySettings(sp, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    const appear = 15
    const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    container.filters = [ alphaFilter ]

  
    sub0
      .to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })
      // .to(sprites['doors_purple'], appear*.25, { pixi:{ saturation: 0 } })
      .to(sprites['doors_purple'], appear*.25, { pixi:{ alpha: 0 }, ease: Linear.easeNone })
      .add([
        TweenMax.to(front_container, appear*1, { pixi:{ scale: 4.2, x: '+=4', y: '-=730' }, ease: Cubic.easeIn }),
        TweenMax.to(bkg_container, appear*1, { pixi:{ scale: 3.0, x: '+=4', y: '-=730' }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['doors_open'], appear*0.25, { alpha: 1, ease: Linear.easeNone, delay: appear*.65 }),
      ])

    this.$tl.add(sub0, 56)

  },
  mounted() {

    // console.log('Scene12');
   
  }
}
</script>
